export interface InspectPlanDto {
    equipmentCd: string;      // 설비 코드
    inspectCd: string;        // 점검 코드
    inspectCycle: string;     // 점검 주기
    remark: string;           // 비고
    
    // 감사/추적 필드
    insertDt: string;         // ZonedDateTime을 string으로 매핑
    insertUser: string;
    insertForm: string;
    updateDt: string;         // ZonedDateTime을 string으로 매핑
    updateUser: string;
    updateForm: string;
}

export const defaultInspectPlanDto: InspectPlanDto = {
    equipmentCd: '',
    inspectCd: '',
    inspectCycle: '',
    remark: '',
    insertDt: '',
    insertUser: '',
    insertForm: '',
    updateDt: '',
    updateUser: '',
    updateForm: ''
}